import React from 'react';
import './App.css';
import { Header } from 'semantic-ui-react';

function App() {
  return (
    <div>
      <Header as='h2' content='It works :-)'/>
    </div>
  );
}

export default App;